import { render, staticRenderFns } from "./zonglan.vue?vue&type=template&id=cdd16fd6&scoped=true&"
import script from "./zonglan.vue?vue&type=script&lang=js&"
export * from "./zonglan.vue?vue&type=script&lang=js&"
import style0 from "./zonglan.vue?vue&type=style&index=0&id=cdd16fd6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd16fd6",
  null
  
)

export default component.exports